import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
const {Paper, Set, Circle, Rect, Text, Path} = require('react-raphael');

function PreviewItem(attrs) {
    const {title, current, showCatalog, disabled} = attrs;
    const btnDisabled = disabled ? true: false;
    const disabledCls = btnDisabled ? ' disabled' : '';
    const btnCls = 'col-md-4 px-3';

    return(
        <div className={btnCls} onClick={showCatalog}>
            <p className={'fw-bold text-center pframes-preview-selector-title'}>{title}</p>
            <div className={'text-center'}>
                <img className={'img img-fluid object-fit-cover border'}
                     src={current?.img}
                     title={current?.title}
                     alt={current?.title}/>
            </div>
            <button className={'btn btn-danger rounded-0 w-100' + disabledCls} >
                <svg xmlns="http://www.w3.org/2000/svg"
                     width="16"
                     height="16"
                     fill="currentColor"
                     className="bi bi-chevron-down"
                     viewBox="0 0 16 16">
                    <path fillRule="evenodd"
                          d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                </svg>
            </button>
            <p className={'text-center py-2 pframes-preview-selector-item'}>
                {current?.title}
            </p>
        </div>
    )
}

function CatalogSelector(attrs){
    const {name, title, itemList, itemCls, maxHeight, onSelect, onClose} = attrs;
    const style = Object.assign({}, {maxHeight: maxHeight});

    return (
        <div className={'card'}>
            <div className={'header'}>
                <h4 className={'text-danger'}>{title}
                <span className={'pull-right close-icon'} onClick={onClose}>x</span>
                </h4>
            </div>
            <div className="card-body pframes-catalog-cont" style={style}>
                <div className="row g-2">
                    {itemList.map((item, key)=>{
                        return (
                            <div key={key}
                                 className={'pframes-catalog-item ' + itemCls}
                                 onClick={()=>onSelect(name, item)}>
                                <img className={'img img-fluid object-fit-cover border pframes-catalog-item-img'}
                                     src={item?.img}
                                     title={item?.title}
                                     alt={item?.title}/>
                                <p className={'pt-2 text-muted text-center small pframes-catalog-item-title'}>
                                    {item?.title}
                                </p>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

const post_config = {
    xsrfCookieName: 'csrftoken',
    xsrfHeaderName: 'X-CSRFToken',
    withCredentials: true
}

function PFrame(props){
    const divBlock = useRef(null);
    const {frame, profilesList, colorList, planeList, frezList, handleList, updateFn} = props;

    const [showCatalog, setShowCatalog] = useState('');
    const minProfileHeight = frame?.minProfileHeight || 10;
    const maxProfileHeight = frame?.maxProfileHeight || 5000;
    const minProfileWidth = frame?.minProfileWidth || 10;
    const maxProfileWidth = frame?.maxProfileWidth || 5000;

    const currentHeight = frame?.height || 0
    const currentWidth = frame?.width || 0
    const currentCount = frame?.count || 1
    const defaultFrez = {
        id: 0,
        type: "unset",
        img: null,
        prefix: "Ф",
        title: "Без петель",
        default_count: 0,
        default_offset: 0,
        can_add: false,
        items: null
    };
    const defaultHandle = {
        id: 0,
        type: "unset",
        img: null,
        prefix: "",
        title: "Без сверления",
        default_count: 0,
        default_x_offset: 0,
        default_y_offset: 0,
        can_add: false,
        items: null
    };

    const currentFrez = frame?.freztype || Object.assign({}, defaultFrez);
    const currentHandle = frame?.handletype || Object.assign({}, defaultHandle);

    const checkHeight = () => {
        let res = ''
        if (!currentHeight) return '';
        if (currentHeight < minProfileHeight) {
               res = 'Мин. высота ' + minProfileHeight + ' мм.';
        } else if (currentHeight > maxProfileHeight) {
            res = 'Макс. высота ' + maxProfileHeight + ' мм.';
        }
        return res;
    }

    const heightErr = checkHeight();

    const getFrezTypes = () => {
        if(frame?.profile?.freztypes?.length > 0){
            const flist = frezList.filter((item)=> {
                return frame?.profile?.freztypes?.indexOf(item.id) >= 0
            });
            return flist
        }
        return [defaultFrez]
    }

    const getHandleTypes = () => {
        if(frame?.profile?.handletypes?.length > 0){
            return handleList.filter((item)=> {
                return frame?.profile?.handletypes?.indexOf(item.id) >= 0
            })
        }
        return [defaultHandle]
    }

    const checkWidth = (e) => {
        let res = '';
        if (!currentWidth) return res;
        if (currentWidth < minProfileWidth) {
               res = 'Мин. ширина ' + minProfileWidth + ' мм.';
        } else if (currentWidth > maxProfileWidth) {
            res = 'Макс. ширина ' + maxProfileWidth + ' мм.';
        }
        return res;
    }
    const widthErr = checkWidth();

    const countErr = '';

    const handleShowSelect = (item) => {
        setShowCatalog(item);
        //todo: navigate
    }

    const handleSetHeight = (e) => {
        const val = e.target.value ? Number(e.target.value) : null;
        if (val && Number.isInteger(val)) {
            updateFn(frame, 'height', val);
        }
    }

    const handleSetWidth = (e) => {
        const val = e.target.value ? Number(e.target.value) : null
        if (val && Number.isInteger(val)) {
            updateFn(frame, 'width', val);
        }
    }

    const handleSetCount = (e) => {
        const val = e.target.value ? Number(e.target.value) : null
        if (val && Number.isInteger(val)) {
            updateFn(frame, 'count', val);
        }
    }

    const handleSelectCat = (item, el) => {
      updateFn(frame, item, el);
      handleShowSelect('');
    }

    const handleSetFrezPosition = (e, item) =>{
        const val = e.target.value ? Number(e.target.value) : null;
        let new_frez = Object.assign({}, currentFrez, {'items': []});
        currentFrez.items.forEach((frez) => {
            if(item.position===frez.position){
                new_frez.items.push(Object.assign({}, frez, {"offset": val}));
            }else{
                new_frez.items.push(Object.assign({}, frez));
            }
        });
        updateFn(frame, 'freztype', new_frez);
    }

    const handleSetFrezCount = (e) =>{
        const val = e.target.value ? Number(e.target.value) : currentFrez.default_count;
        let new_frez = Object.assign({}, currentFrez, {'items': []});
        if (currentFrez.items){
            if (currentFrez.items.length >= val){
                new_frez.items = [...currentFrez.items.slice(0, val)]
            }else{
                new_frez.items = [...currentFrez.items]
                for (let i = currentFrez.items.length + 1; i < val + 1; i++){
                    new_frez.items.push({"position": i, "offset": new_frez.default_offset, "from": i % 2 == 0 ? "bottom": "top"});
                }
            }
        }else{
            for (let i = 1; i < val + 1; i++){
                new_frez.items.push({"position": i, "offset": new_frez.default_offset, "from": i % 2 == 0 ? "bottom": "top"});
            }
        }
        updateFn(frame, 'freztype', new_frez);
    }

    const handleChangeFrez = (val) => {
        if (val === "unset") {
            updateFn(frame, 'freztype', defaultFrez);
        }else{
            const FrezForSet = getFrezTypes().find((item)=> { return item.type===val});
            let new_frez = Object.assign({}, FrezForSet, {'items': []});
            if (currentFrez?.type === "unset"){
                for (let i = 1; i < new_frez.default_count + 1; i++){
                    new_frez.items.push({"position": i, "offset": new_frez.default_offset, "from": i % 2 == 0 ? "bottom": "top"});
                }
            }else{
                let offset_default = currentFrez.items?.every((item)=>{ return item.offset===currentFrez.default_offset});
                if (offset_default && currentFrez.items?.length === currentFrez.default_count){
                    for (let i = 1; i < new_frez.default_count + 1; i++){
                        new_frez.items.push({"position": i, "offset": new_frez.default_offset, "from": i % 2 == 0 ? "bottom": "top"})
                    }
                }else{
                    new_frez.items = [...currentFrez.items];
                }
            }
            updateFn(frame, 'freztype', new_frez);
        }
    }

    const renderFrezDetail = () => {
        return (
            <>
                {currentFrez?.items?.map((item, key)=>{
                    return (
                        <div key={key} className={'row'}>
                            <div className={'col text-end'}>
                                {`${currentFrez?.prefix}${item.position} отступ ${item.from === 'top' ? 'сверху' : 'снизу'}: `}
                            </div>
                            <div className={'col'}>
                                <div className="input-group input-group-sm mb-3">
                                    <input type="number"
                                           className="form-control"
                                           min={0}
                                           value={item.offset}
                                           onChange={(e)=>{handleSetFrezPosition(e, item)}}
                                    />
                                    <span className="input-group-text">мм.</span>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </>
        )
    }

    const handleChangeHandle = (val) => {
        if (val === "unset") {
            updateFn(frame, 'handletype', defaultHandle);
        }else{
            const HandleForSet = getHandleTypes().find((item)=> { return item.type===val});
            const default_y = Math.ceil(currentHeight / 2);
            let new_handle = Object.assign({}, HandleForSet, {'items': []});
            if (currentHandle?.type === "unset"){
                for (let i = 1; i < new_handle.default_count + 1; i++){
                    new_handle.items.push(
                        {"position": i,
                            "offset_x": new_handle.default_x_offset,
                            "offset_y": i  === 1 ? default_y : new_handle.default_y_offset,
                            "from": i  === 1 ? "bottom" : "between"
                        });
                }
            }else{
                let offset_default_x = currentHandle.items?.every((item)=>{
                    return item.offset_x===currentHandle.default_x_offset
                });
                let offset_default_y = currentHandle.items?.every((item, ind)=>{
                    return ind===0 ? item.offset_y===default_y : item.offset_y===currentHandle.default_y_offset
                });
                if (offset_default_x && offset_default_y && currentHandle.items?.length === currentHandle.default_count){
                    for (let i = 1; i < new_handle.default_count + 1; i++){
                        new_handle.items.push(
                            {"position": i,
                            "offset_x": new_handle.default_x_offset,
                            "offset_y": i  === 1 ? default_y : new_handle.default_y_offset,
                            "from": i  === 1 ? "bottom" : "between"
                        })
                    }
                }else{
                    new_handle.items = [...currentHandle.items];
                }
            }
            updateFn(frame, 'handletype', new_handle);
        }
    }

    const handleSetHandleCount = (e) =>{
        const val = e.target.value ? Number(e.target.value) : currentHandle.default_count;
        let new_handle = Object.assign({}, currentHandle, {'items': []});
        if (currentHandle.items){
            if (currentHandle.items.length >= val){
                new_handle.items = [...currentHandle.items.slice(0, val)]
            }else{
                new_handle.items = [...currentHandle.items]
                for (let i = currentHandle.items.length + 1; i < val + 1; i++){
                    new_handle.items.push(
                        {"position": i,
                        "offset_x": new_handle.default_x_offset,
                        "offset_y": i  === 1 ? default_y : new_handle.default_y_offset,
                        "from": i  === 1 ? "bottom" : "between"
                        }
                    );
                }
            }
        }else{
            for (let i = 1; i < val + 1; i++){
                new_handle.items.push(
                    {"position": i,
                        "offset_x": new_handle.default_x_offset,
                        "offset_y": i  === 1 ? default_y : new_handle.default_y_offset,
                        "from": i  === 1 ? "bottom" : "between"
                    });
            }
        }
        updateFn(frame, 'handletype', new_handle);
    }

    const handleSetHandlePosition = (e, type, item) =>{
        const val = e.target.value ? Number(e.target.value) : null;
        let new_handle = Object.assign({}, currentHandle, {'items': []});
        if (type === 'y'){
            currentHandle.items.forEach((handle) => {
            if(item.position===handle.position){
                new_handle.items.push(Object.assign({}, handle, {"offset_y": val}));
            }else{
                new_handle.items.push(Object.assign({}, handle));
            }
            });
        }else{
            currentHandle.items.forEach((handle) => {
                new_handle.items.push(Object.assign({}, handle, {"offset_x": val}));
            });
        }
        updateFn(frame, 'handletype', new_handle);
    }

    const renderHandleDetail = () => {
        return (
            <>
                {currentHandle?.items?.map((item, key)=>{
                    return (
                        <div key={key} className={'row'}>
                            <div className={'col text-end'}>
                                {`${currentHandle?.prefix}${item.position} отступ ${item.from === 'bottom' ? 'снизу' : 'между'}: `}
                            </div>
                            <div className={'col'}>
                                <div className="input-group input-group-sm mb-3">
                                    <input type="number"
                                           className="form-control"
                                           min={0}
                                           value={item.offset_y}
                                           onChange={(e)=>{handleSetHandlePosition(e, 'y', item)}}
                                    />
                                    <span className="input-group-text">мм.</span>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </>
        )
    }

    const getWDoubleArrowPath = (x0, y0, x1, y1, size=4) => {
        return [`M${x0+size} ${y0}L${x1-size} ${y1}`,
         `M${x0} ${y0}L${x0+size} ${y0+size}L${x0+size} ${y0-size}ZM${x0+size} ${y0}`,
         `M${x1} ${y1}L${x1-size} ${y1+size}L${x1-size} ${y1-size}ZM${x1+size} ${y1}`,
        ]
    }

    const getHDoubleArrowPath = (x0, y0, x1, y1, size=4) => {
        return [`M${x0} ${y0+size}L${x1} ${y1-size}`,
         `M${x0} ${y0}L${x0+size} ${y0+size}L${x0-size} ${y0+size}ZM${x0+size} ${y0}`,
         `M${x1} ${y1}L${x1-size} ${y1-size}L${x1+size} ${y1-size}ZM${x1+size} ${y1}`,
        ]
        //`M${x1} ${y1}L${x1-size} ${y1+size}L${x1-size} ${y1-size}ZM${x1+size} ${y1}`,
    }

    const renderPreview = () => {
        const screenWidth = window.innerWidth;
        const maxWidth = screenWidth > 550 ? 500: screenWidth - 30;

        const textColor = "#212529";
        const kWH = currentWidth / currentHeight < 0.8 ? 0.8 : currentWidth / currentHeight > 1.15 ? 1.15: currentWidth / currentHeight ;
        const lineW = 2;
        const lineColor = "#A7A7A7";
        const profileColor = frame?.color?.color || "#FFFCCC";
        const bgColor = frame?.color?.colorC || "#f1f1f1";
        const profileDrawWidth = 10;

        const maxHeight = Math.ceil(maxWidth / kWH);
        const wOffset = Math.ceil(maxWidth * 0.15);
        const hOffset = Math.ceil(maxWidth * 0.15);
        const paperWidth = maxWidth - 2 * wOffset;
        const paperHeight = maxHeight - 2 * hOffset;
        const profileHK = currentHeight / paperHeight;

        const sizeOffset = 20;
        const frezOffset = 30;
        const frezAttr = {"stroke":"#1a1a1a","stroke-width":2};
        const frezLineAttr = {"stroke":"#1a1a1a","stroke-width":1};
        const frezTextAttr = {"fill":"#000", "text-anchor": "start", "font-size": 14};
        const handleAttr = {"stroke":"#1a1a1a","stroke-width":2};
        const handleLineAttr = {"stroke":"#1a1a1a","stroke-width":1};
        const handleTextAttr = {"fill":"#000", "text-anchor": "end", "font-size": 14};
        const handleXTextAttr = {"fill":"#000", "text-anchor": "start", "font-size": 12};

        const getFrezAbsoluteOffset = () =>{
            let totals = {},
                positions = {}
            frame?.freztype?.items?.forEach((item, ind)=>{
                if(item.from in totals){
                    totals[item.from] += item.offset
                }else{
                    totals[item.from] = item.offset
                }
                positions[item.position] = totals[item.from]
            })
            return [totals, positions]
        }

        const [frezTotals, frezPositions] = getFrezAbsoluteOffset();

        // initial data for frez
        let frez_yt = hOffset + lineW;
        let frez_yb = hOffset + paperHeight - lineW;
        const frez_cx = wOffset + profileDrawWidth + lineW + frezOffset;
        const frez_cr = 7;
        const handle_c_offset = 50;
        const handle_cr = 7;
        let handle_yb = hOffset + paperHeight - lineW;
        let handle_cx = wOffset + paperWidth - lineW - handle_c_offset;

        return (
            <div>
                <Paper width={maxWidth} height={maxHeight}>
                    <Set>
                         <Rect x={wOffset}
                               y={hOffset}
                               width={paperWidth}
                               height={paperHeight}
                               attr={{"stroke": lineColor,"stroke-width":lineW, "fill": profileColor}}/>
                        <Rect x={wOffset + profileDrawWidth + lineW}
                               y={hOffset+ profileDrawWidth + lineW}
                               width={paperWidth - 2 * (profileDrawWidth + lineW)}
                               height={paperHeight- 2 * (profileDrawWidth + lineW)}
                               attr={{"stroke": lineColor,"stroke-width":lineW, "fill": bgColor}}/>
                    </Set>
                    <Set>
                        <Text x={Math.ceil(wOffset + paperWidth/2)} y={hOffset-(2 * sizeOffset)} text={`${currentWidth} мм.`} attr={{"fill":textColor, "font-size": 14}}/>
                        <Path d={getWDoubleArrowPath(wOffset, hOffset-sizeOffset, paperWidth+wOffset, hOffset-sizeOffset)} attr={{"stroke": textColor}}/>
                        <Path d={getHDoubleArrowPath(wOffset-sizeOffset, hOffset, wOffset-sizeOffset, hOffset+paperHeight)} attr={{"stroke": textColor}}/>
                        <Text x={wOffset - 2 * sizeOffset}
                              y={Math.ceil(hOffset + paperHeight/2)}
                              text={`${currentHeight} мм.`}
                              rotate={{"deg": -90}}
                              attr={{"fill":textColor, "font-size": 14}}
                        />
                    </Set>
                    {frame?.freztype?.items?.length > 0 ?
                        <Set>
                            {frame.freztype.items.map((item, ind)=>{
                                 const pos_y = frezPositions[item.position];
                                 const count = item.position % 2 === 0 ? item.position /2 : Math.ceil(item.position /2);
                                 const minY = 40 * count + profileDrawWidth + lineW;
                                 const top_offset = pos_y / profileHK  > minY ? pos_y / profileHK : minY;
                                 const cy = item.from === 'top' ? hOffset + top_offset: hOffset + paperHeight - top_offset;
                                 const py0 = item.from === 'top' ? frez_yt: cy;
                                 const py1  = item.from === 'top' ? cy: frez_yb;
                                 const text_cx = frez_cx + 5;
                                 const text_cy = ((py1 - py0) / 2) + py0;

                                 if(item.from === 'top'){
                                     frez_yt = cy;
                                 }else{
                                     frez_yb = cy;
                                 }

                                return(
                                    <Set key={ind}>
                                        <Circle x={frez_cx} y={cy} r={frez_cr} attr={frezAttr}/>
                                        <Path d={getHDoubleArrowPath(frez_cx, py0, frez_cx, py1)} attr={frezLineAttr}/>
                                        <Text x={text_cx}
                                              y={text_cy}
                                              text={`${frame?.freztype?.prefix}${item.position} - ${item.offset}мм.`}
                                              attr={frezTextAttr}
                                        />
                                    </Set>
                                )
                            })}
                        </Set>
                        : null}
                    {frame?.handletype?.items?.length > 0 ?
                        <Set>
                            {frame.handletype.items.map((item, ind)=>{
                                const pos_y = item.offset_y;
                                const minY = 40 + profileDrawWidth + lineW;
                                const top_offset = pos_y / profileHK  > minY ? pos_y / profileHK : minY;
                                const cy = handle_yb - top_offset;
                                const py0 = cy;
                                const py1  = handle_yb;
                                const text_cx = handle_cx - 5;
                                const text_cy = ((py1 - py0) / 2) + py0;

                                handle_yb = cy;

                                return (
                                    <Set key={ind}>
                                        <Circle x={handle_cx} y={cy} r={handle_cr} attr={handleAttr}/>
                                        <Path d={getHDoubleArrowPath(handle_cx, py0, handle_cx, py1)}
                                              attr={handleLineAttr}/>
                                        <Text x={text_cx} y={text_cy}
                                              text={`${frame?.handletype?.prefix}${item.position} - ${item.offset_y}мм.`}
                                              attr={handleTextAttr}
                                        />
                                        {ind===0 ?<>
                                            <Path d={getWDoubleArrowPath(handle_cx, py0, paperWidth+wOffset, py0)}
                                                  attr={handleLineAttr}/>
                                            <Text x={handle_cx + handle_cr}
                                                  y= {py0 - 2 * handle_cr}
                                                  text={`${item.offset_x}мм.`}
                                                  attr={handleXTextAttr}/>
                                            </>
                                            :null}
                                    </Set>)
                            })}
                        </Set>
                    : null}
                </Paper>
            </div>
        )
    }

    return (<>
        <div className={'row'}>
            <div className={'col-md-7'}>
                <div className={'row mb-3'}>
                    <div className={'col-6 col-md-4'}>
                        <label htmlFor="heigh-input" className="form-label fw-bold">Высота фасада</label>
                        <div className="input-group mb-3">
                            <input type="number"
                                   className="form-control fw-bold rounded-0"
                                   placeholder="500"
                                   min={minProfileHeight}
                                   max={maxProfileHeight * 2}
                                   value={currentHeight}
                                   onChange={handleSetHeight}
                                   aria-label="Высота фасада" aria-describedby="heigh-input"/>
                            <span className="input-group-text rounded-0">мм</span>
                        </div>
                        {heightErr.length > 0 ?
                            <label htmlFor="heigh-input"
                                   className="form-label fw-bold text-danger">{heightErr}</label>
                            : null
                        }
                    </div>
                    <div className={'col-6 col-md-4'}>
                        <label htmlFor="heigh-input" className="form-label fw-bold">Ширина фасада</label>
                        <div className="input-group mb-3">
                            <input type="number"
                                   className="form-control fw-bold rounded-0"
                                   placeholder="400"
                                   min={minProfileWidth}
                                   max={maxProfileWidth}
                                   value={currentWidth}
                                   onChange={handleSetWidth}
                                   aria-label="Ширина фасада" aria-describedby="width-input"/>
                            <span className="input-group-text rounded-0">мм</span>
                        </div>
                        {widthErr.length > 0 ?
                            <label htmlFor="heigh-input"
                                   className="form-label fw-bold text-danger">{widthErr}</label>
                            : null
                        }
                    </div>
                    <div className={'col-12 col-md-4'}>
                        <label htmlFor="heigh-input" className="form-label fw-bold">Количество фасадов</label>
                        <div className="input-group mb-3">
                            <input type="number"
                                   className="form-control fw-bold rounded-0"
                                   placeholder="400"
                                   min={1}
                                   max={100}
                                   value={currentCount}
                                   onChange={handleSetCount}
                                   aria-label="Количество фасадов" aria-describedby="width-input"/>
                            <span className="input-group-text rounded-0">шт</span>
                        </div>
                        {countErr.length > 0 ?
                            <label htmlFor="heigh-input"
                                   className="form-label fw-bold text-danger">{countErr}</label>
                            : null
                        }
                    </div>
                </div>
                <div className={'row mb-3'}>
                    <PreviewItem
                        title={'Профиль'}
                        current={frame?.profile}
                        showCatalog={() => handleShowSelect('profile')}
                        disabled={profilesList.length < 2}
                    />
                    <PreviewItem
                        title={'Цвет'}
                        current={frame?.color}
                        showCatalog={() => handleShowSelect('color')}
                        disabled={colorList.length < 2}
                    />
                    <PreviewItem
                        title={'Вставка'}
                        current={frame?.plane}
                        showCatalog={() => handleShowSelect('plane')}
                        disabled={planeList.length < 2}
                    />
                </div>
                {showCatalog === 'profile' ?
                    <div className={'row'}>
                        <CatalogSelector
                            name={'profile'}
                            title={'Выбрать профиль'}
                            itemList={profilesList}
                            itemCls={'col-4'}
                            maxHeight={600}
                            onSelect={handleSelectCat}
                            onClose={() => handleShowSelect('')}/>
                    </div> : null}
                {showCatalog === 'color' ?
                    <div className={'row'}>
                        <CatalogSelector
                            title={'Выбрать цвет'}
                            name={'color'}
                            itemList={colorList}
                            itemCls={'col-3'}
                            maxHeight={600}
                            onSelect={handleSelectCat}
                            onClose={() => handleShowSelect('')}/>
                    </div> : null}
                {showCatalog === 'plane' ?
                    <div className={'row'}>
                        <CatalogSelector
                            title={'Выбрать вставку'}
                            name={'plane'}
                            itemList={planeList}
                            itemCls={'col-3'}
                            maxHeight={600}
                            onSelect={handleSelectCat}
                            onClose={() => handleShowSelect('')}/>
                    </div> : null}

                {getFrezTypes().length > 0 ?
                    <div className={'row'}>
                        <div className={'col-sm-8'}>
                            <label className={'form-label fw-bold'}>Фрезеровка под петлю</label>
                            <div className="input-group mb-3">
                                <select className="form-select rounded-0"
                                        value={currentFrez?.type}
                                        onChange={e => handleChangeFrez(e.target.value)}>
                                    {getFrezTypes().map((item, ind) => {
                                        return (
                                            <option key={ind} value={item.type}>
                                                {item.title}
                                            </option>
                                        )
                                    })}
                                </select>
                            </div>
                        </div>
                        {currentFrez?.default_count > 0 ?
                            <div className={'col-sm-4'}>
                                <label htmlFor="heigh-input" className="form-label fw-bold">Количество</label>
                                <div className="input-group mb-3">
                                    <input type="number"
                                           className="form-control fw-bold rounded-0"
                                           placeholder={currentFrez?.default_count}
                                           min={1}
                                           max={20}
                                           value={currentFrez?.items ? currentFrez?.items.length : 0}
                                           onChange={handleSetFrezCount}
                                           aria-label="Количество" aria-describedby="width-input"/>
                                    <span className="input-group-text rounded-0">шт</span>
                                </div>
                            </div>
                            : null}
                    </div> : null
                }
                {currentFrez?.img ?
                    <div className={'row'}>
                        <div className={'col-sm-8'}>
                            {renderFrezDetail()}
                        </div>
                        <div className={'col-sm-4 text-center'}>
                            <img className={'img img-fluid'} style={{'width': '60%'}} src={currentFrez.img}></img>
                        </div>
                    </div>
                    :
                    <div className={'row'}>
                        <div className={'col-12'}>
                            {renderFrezDetail()}
                        </div>
                    </div>
                }
                {getHandleTypes().length > 0 ?
                    <div className={'row'}>
                        <div className={'col-sm-8'}>
                            <label className={'form-label fw-bold'}>Сверление в фасаде под ручку</label>
                            <div className="input-group mb-3">
                                <select className="form-select rounded-0"
                                        value={currentHandle?.type}
                                        onChange={e => handleChangeHandle(e.target.value)}>
                                    {getHandleTypes().map((item, ind) => {
                                        return (
                                            <option key={ind} value={item.type}>
                                                {item.title}
                                            </option>
                                        )
                                    })}
                                </select>
                            </div>
                        </div>
                        {currentHandle?.default_count > 0 ?
                            <div className={'col-sm-4'}>
                                <label htmlFor="heigh-input" className="form-label fw-bold">Количество</label>
                                <div className="input-group mb-3">
                                    <input type="number"
                                           className="form-control fw-bold rounded-0"
                                           placeholder={currentHandle?.default_count}
                                           min={1}
                                           max={20}
                                           value={currentHandle?.items ? currentHandle?.items.length : 0}
                                           onChange={handleSetHandleCount}
                                           aria-label="Количество" aria-describedby="width-input"/>
                                    <span className="input-group-text rounded-0">шт</span>
                                </div>
                            </div>
                            : null}
                    </div>
                    : null}
                <div className={'row'}>
                    <div className={'col-sm-6'}>
                        {renderHandleDetail()}
                    </div>
                    <div className={'col-sm-6'}>
                        {currentHandle?.items?.length > 0 ?
                            <>
                                <div className={'row'}>
                                    <div className={'col text-end'}>Отстут от профиля</div>
                                        <div className={'col'}>
                                        <div className="input-group input-group-sm mb-3">
                                            <input type="number"
                                                   className="form-control"
                                                   placeholder={currentFrez?.default_x_offset}
                                                   value={currentHandle?.items[0]?.offset_x}
                                                   onChange={(e) => {
                                                               handleSetHandlePosition(e, 'x', null)
                                                           }}
                                                   aria-label="Отстут от профиля" aria-describedby="width-input"/>
                                            <span className="input-group-text">мм.</span>
                                        </div>
                                    </div>
                                </div>
                            </>
                            : null}
                        {currentHandle?.img ?
                            <div className={'row'}>
                                <div className={'col'}></div>
                                <div className={'col'}>
                                    <img className={'img img-fluid'} style={{'width': '100%'}}
                                         src={currentHandle.img}></img>
                                </div>

                            </div>
                            : null}
                    </div>
                </div>

            </div>
            <div className={'col-md-5'} ref={divBlock}>
                <h3 className="text-center"> Лицевая часть: </h3>
                {renderPreview()}
            </div>
        </div>
        </>
    )
}

function PFramesApp({attrs}) {
    const materialsUrl = attrs.getNamedItem("data-materials").value;
    const costUrl = attrs.getNamedItem("data-cost").value;
    const cartUrl = attrs.getNamedItem("data-cart").value;

    useEffect(() => {

        setIsLoading(true);
        axios.get(materialsUrl, {}).then(res => {
            if (res.status === 200 || res.status === 201){
                setProfilesList(res.data.profilesList);
                setColorList(res.data.colorList);
                setPlaneList(res.data.planeList);
                setDefaultFrame(res.data.defaultFrame);
                setFrezList(res.data.frezTypes);
                setHandleList(res.data.handleTypes);
                if (res.data.frames){
                    setPFrames([...res.data.frames]);
                }else{
                    setPFrames([res.data.defaultFrame]);
                }
                setErrorStr('');
                setIsLoading(false);
                setIsReady(true);
            }else{
                const err = res?.error || defaultError;
                setErrorStr(err);
                setIsLoading(false);
            }
          }).catch(err => {
              setErrorStr(err);
              setIsLoading(false);

          });

  }, []);
    const defaultError = "К сожалению что-то пошло не так( Попробуте повторить позднее...";
    const [isInCart, setInCart] = useState(false);
    const [showCartConfirm, setShowCartConfirm] = useState(false);
    const [errorStr, setErrorStr] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isReady, setIsReady] = useState(false);
    const [profilesList, setProfilesList] = useState([
        {
            id: 12,
            sku: "F221-1",
            title: "Профиль по умолчанию",
            img: "/static/pframes/noimg.jpg"
        },
    ]);
    const [colorList, setColorList] = useState([{
        id: 12,
        sku: "F221-2",
        title: "Серебристый",
        color: "#f1f1f1",
        img: "/static/pframes/noimg.jpg"
    }]);



    const [defaultFrame, setDefaultFrame] = useState({
            id: 1,
            calculated: false,
            freztype: null,
            handletype: null,
            width: 300,
            height: 400,
            count: 1,
            cost: 0,
            profile: {
                id: 12,
                sku: "F221-1",
                title: "Профиль по умолчанию",
                img: "/static/pframes/noimg.jpg",
                minProfileHeight: 10,
                maxProfileHeight: 5000,
                minProfileWidth: 10,
                maxProfileWidth: 5000,
                freztypes: [0],
                handletypes: [0],
            },
            color: {
                id: 12,
                sku: "F221-1",
                title: "Серебристый",
                img: "/static/pframes/noimg.jpg"
            },
            plane: {
                id: 12,
                sku: "A222",
                title: "Без наполнения",
                img: "/static/pframes/noimg.jpg"
            }
        });

    const [activeTab, setActiveTab] = useState(0);
    const [PFrames, setPFrames] = useState([
        Object.assign({}, JSON.parse(JSON.stringify(defaultFrame)))
    ]);
    const [planeList, setPlaneList] = useState([]);
    const [frezList, setFrezList] = useState([
            {
            id: 0,
            type: "unset",
            img: null,
            prefix: "Ф",
            title: "Без петель",
            default_count: 0,
            default_offset: 0,
            can_add: false,
            items: null
        }
    ]);
     const [handleList, setHandleList] = useState([
         { id: 0,
            type: "unset",
            img: null,
            prefix: "",
            title: "Без сверления",
            default_count: 0,
            default_x_offset: 0,
            default_y_offset: 0,
            can_add: false,
            items: null
            }]);

    const FrameTitle = 'Фасад';

    const updatePFrameParams = (frame, option, data) => {

        let cframe = {}
        if (option === "freztype"){
            const calculated = frame?.calculated ? frame.freztype?.items?.length === data.items?.length : false;
            cframe = Object.assign({}, JSON.parse(JSON.stringify(frame)), {[option]: data, 'calculated': calculated});
        }else if (option === "handletype"){
            const calculated = frame?.calculated ? frame.handletype?.items?.length === data.items?.length : false;
            cframe = Object.assign({}, JSON.parse(JSON.stringify(frame)), {[option]: data, 'calculated': calculated});
        }else{
            cframe = Object.assign({}, JSON.parse(JSON.stringify(frame)), {[option]: data, 'calculated': false});
        }
        setPFrames(prevDataList =>
            [...prevDataList.map(item => (item.id === cframe.id ? cframe : item))]
        );
    }

    const currentFrame = PFrames?.length > activeTab ? PFrames[activeTab]: null;
    const allCalculated  = PFrames?.length > 0 ? PFrames?.every((item)=> item?.calculated === true) : false;
    const totalCost = PFrames?.length > 0 ? PFrames?.reduce((prev, item) => prev + item.cost, 0) : 0;

    const addFrame = () => {
        const newTab = PFrames?.length || 0;
        setPFrames(prevState => [...prevState, Object.assign({}, defaultFrame, {id: newTab+1})])
        setActiveTab(newTab);

    }
    const handleSetTab = (val) =>{
        setActiveTab(val);
    }

    const handleCalculate = () =>{
        if (!isLoading){
            setIsLoading(true);
            const reqData = Object.assign({}, {'frames': PFrames});
            axios.post(costUrl, reqData, post_config).then( res => {
                if (res.status === 200 || res.status === 201){
                    const resFrames = [...res.data.frames];
                    setPFrames([...PFrames?.map((item) =>{
                        let res_item = resFrames?.find((element) => element.id === item.id);
                        if (res_item !== undefined){
                            const realItem = Object.assign({},
                                JSON.parse(JSON.stringify(item)),
                                {'cost': res_item.cost, 'calculated': res_item.calculated});
                            return realItem
                        }
                        return Object.assign({}, JSON.parse(JSON.stringify(item)))
                    })])

                }else{
                    console.log("Calculate error:", res)
                }
                setIsLoading(false);
            }).catch(err=> {
                console.log("Calculate catch:", err);
                setIsLoading(false);
            });
        }
    }

    const handleToCart = () =>{
        if (!isLoading&&!isInCart){
            setIsLoading(true);
            const stamp = Math.floor(Date.now() / 1000);
            const data = Object.assign({}, {'frames': PFrames});
            const reqData = Object.assign({}, {'app': 'pframes', 'data': data, 'quantity': 1, 'id': stamp});
            axios.post(cartUrl, reqData, post_config).then( res => {
                if (res.status === 200 || res.status === 201){
                    setInCart(true);
                    setErrorStr('');
                    setShowCartConfirm(true);

                }else{
                    console.log("handleToCart error:", res);
                    setErrorStr(res?.data?.error || defaultError);
                }
                setIsLoading(false);
            }).catch(err=> {
                console.log("handleToCart catch:", err);
                setErrorStr(defaultError);
                setIsLoading(false);
            });
        }
    }
    const handleCancel = (e) =>{
        setErrorStr('');
    }

    const handleCloseSuccess = (e) =>{
        setShowCartConfirm(false);
    }

    const handleNavigateToCart = (e) =>{
        window.location.href = '/shop/ncart/';
    }

    return (
        <div className={'pframes-app'}>
            {errorStr.length >0 ?
            <div className="modal show" tabIndex="-1" style={{'display': 'block'}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title text-danger">Ошибка</h5>
                            <button type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={handleCancel}>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>{errorStr}</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                    onClick={handleCancel}>Закрыть
                            </button>
                        </div>
                    </div>
                </div>
            </div>: null
            }
            {showCartConfirm ? <div className="modal show" tabIndex="-1" style={{'display': 'block'}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title text-success">Добавление в корзину</h5>
                            <button type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={handleCloseSuccess}>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Фасады успешно добавлены!</p>
                            <p>Перейти в корзину?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                    onClick={handleCloseSuccess}>Остаться
                            </button>
                            <button type="button"
                                    className="btn btn-success"
                                    data-bs-dismiss="modal"
                                    onClick={handleNavigateToCart}>Перейти в корзину
                            </button>
                        </div>
                    </div>
                </div>
            </div> : null}
            <div className={'row py-2'}>
                <div className={'col-md-12'}>
                    <ul className="nav nav-underline pb-3" role="tablist">
                        {PFrames?.map((item, key) => {
                            return (
                                <li className="nav-item mx-2" role="presentation" key={key}>
                                    <button className={`fs-4 nav-link nav-contact${key === activeTab ? ' active' : ''}`}
                                            aria-selected={key === activeTab ? 'true' : 'false'}
                                            onClick={(e) => handleSetTab(key)}>
                                        {`Фасад ${key + 1}`}
                                    </button>
                                </li>
                            )
                        })}
                        <li className="nav-item" role="presentation">
                            <button className={`fs-4 nav-link nav-contact`} aria-selected="false" onClick={addFrame}>
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     width="24" height="24"
                                     fill="currentColor"
                                     className="bi bi-plus me-2"
                                     viewBox="0 0 16 16">
                                    <path
                                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                                </svg>
                                <span>Добавить</span>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <div className={'row'}>
                <div className={'col-md-12'}>
                    {currentFrame ?
                        <PFrame frame={currentFrame}
                                profilesList={profilesList}
                                colorList={colorList}
                                planeList={planeList}
                                frezList={frezList}
                                handleList={handleList}
                                updateFn={updatePFrameParams}/>
                        : null
                    }
                </div>
            </div>
            <div className={'card mt-3'}>
                <div className={'card-header'}>
                    <div className={'row py-2'}>
                        <div className={'col-md-7'}>
                            <h2>Ваш заказ {isInCart ?
                                <span className='text-success'> (добавлен в корзину)</span> : null}</h2>
                        </div>
                        <div className={'col-md-5'}></div>
                    </div>
                </div>
                <div className={'card-body'}>
                    {PFrames?.map((item, key) => {
                        return (
                            <div className={'row py-2'} key={key}>
                                <div className={'col-md-2 text-center'}>
                                    <h5>{`${FrameTitle} ${key + 1}`}
                                        <span className={'d-md-none fw-bold'}> - {item?.count} шт.</span>
                                    </h5>
                                </div>
                                <div className={'col-md-6 pb-3'}>
                                    <span className={'fw-bold'}>
                                        Ширина:
                                    </span>
                                    <span className={'ps-3'}>
                                        {item?.width} мм.
                                    </span>
                                    <span className={'fw-bold ps-3'}>
                                        Высота:
                                    </span>
                                    <span className={'ps-3'}>
                                        {item?.height} мм.
                                    </span><br/>
                                    <span className={'fw-bold'}>
                                        {item?.profile?.title}
                                    </span>
                                    <span className={'ps-3'}>
                                        {item?.color?.title} ({item?.color?.sku})
                                    </span><br/>
                                    <span className={'fw-bold'}> Вставка:</span>
                                    <span className={'ps-3'}>
                                        {item?.plane?.title} ({item?.plane?.sku})
                                    </span><br/>
                                    {item?.freztype?.items?.length > 0 ?
                                        <>
                                            <span
                                                className={'fw-bold pe-2'}>{`Фрезеровка под петлю ${item.freztype?.title} - ${item.freztype?.items?.length} шт:`}</span>
                                            {item.freztype.items.map((frez, ind) => {
                                                return (
                                                    <div className={'py-1 small text-muted'} key={ind}>
                                                        {`${item.freztype?.prefix}${frez.position} отступ ${frez.from === 'top' ? 'сверху' : 'снизу'} - ${frez.offset} мм.`}
                                                    </div>
                                                )
                                            })}
                                        </>
                                        : null
                                    }
                                    {item?.handletype?.items?.length > 0 ?
                                        <>
                                            <span
                                                className={'fw-bold pe-2'}>{`Сверление ${item.handletype?.title} - ${item.handletype?.items?.length} шт:`}</span><br/>
                                            <span
                                                className={'py-1 small text-muted'}>{`Отступ от профиля ${item.handletype?.items[0].offset_x} мм.`}</span>
                                            {item.handletype.items.map((frez, ind) => {
                                                return (
                                                    <div className={'py-1 small text-muted'} key={ind}>
                                                        {`${item.handletype?.prefix}${frez.position} отступ ${frez.from === 'bottom' ? 'снизу' : 'между'} - ${frez.offset_y} мм.`}
                                                    </div>
                                                )
                                            })}
                                        </>
                                        : null}
                                </div>
                                <div className={'d-none d-md-block col-md-1 text-center'}>
                                    <span className={'fw-bold'}>{item?.count} шт.</span>
                                </div>
                                <div className={'col-12 col-md-3 text-center'}>
                                    <h5 className={'fw-bold'}>{item?.calculated ? `${item?.cost} руб.` : '-'} </h5>
                                </div>
                            </div>)
                    })
                    }
                </div>
                <div className={'card-footer'}>
                    <div className={'row py-3'}>

                        <div className={'col-6 col-md-9 text-md-end'}>
                            <h5 className={'fw-bold'}>Итог:</h5>
                        </div>
                            {allCalculated ?
                                <div className={'col-6 col-md-3 text-md-center'}>
                                    <h5 className={'fw-bold'}>{totalCost} руб.</h5>
                                    </div>:
                                <div className={'col-12 col-md-3 text-md-center'}>
                                    <button type="button"
                                            onClick={handleCalculate}
                                            className="btn btn-success bshadow td_calc-order-button btn-lg w-100"
                                            title="Расчитать стоимость рамочного профиля распил">Расчитать стоимость
                                    </button>
                                </div>
                            }
                    </div>
                    <div className={'row'}>
                        <div className={'col-md-9 text-end'}>
                        </div>
                        <div className={'col-md-3 text-center'}>
                            <button type="button"
                                    onClick={handleToCart}
                                    className={allCalculated || isInCart ? 'btn btn-danger bshadow td_calc-order-button btn-lg w-100' : 'btn btn-danger bshadow td_calc-order-button btn-lg w-100 disabled'}
                                    title="Добавить профиль в корзину">Добавить в корзину
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PFramesApp;